import { render, staticRenderFns } from "./Description-Mobile.vue?vue&type=template&id=42b352d6&scoped=true"
import script from "./Description-Mobile.vue?vue&type=script&lang=js"
export * from "./Description-Mobile.vue?vue&type=script&lang=js"
import style0 from "./Description-Mobile.vue?vue&type=style&index=0&id=42b352d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b352d6",
  null
  
)

export default component.exports